module.exports = __webpack_public_path__ + "static/media/Descriptiontooltipimage.90bb0d75.png";